import { Controller } from "@hotwired/stimulus"

// Reveals or hides a field based on whether a watched input's value
// matches the expected value.

export default class extends Controller {
  static targets = ["content"]
  static values = { value: String }

  toggle(event) {
    const match = event.target.value === this.valueValue
    this.contentTargets.forEach((element) => {
      const hidden = !match

      element.classList.toggle("hidden", hidden)
      if (hidden) this.clearFields(element)
    })
  }

  clearFields(element) {
    // Make sure we cover all bases here - we want to clear all fields
    element.querySelectorAll("input, select, textarea").forEach((field) => {
      if (field.disabled) return

      if (["checkbox", "radio"].includes(field.type)) {
        field.checked = false
        return
      }

      if (field.tagName === "SELECT") {
        field.selectedIndex = 0
        return
      }

      field.value = ""
    })
  }
}
